var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Avatar, Conversation, ConversationHeader, ConversationList, Sidebar } from "@chatscope/chat-ui-kit-react";
import { ChevronDownIcon, Pin } from "lucide-react";
import { nanoid } from "nanoid";
import React, { useCallback, useEffect, useRef, useState } from "react";
import chatChannel from "../../../channels/chats_channel";
import { Presence, useChat, User, UserStatus } from "../useChat";
import { createConversation, getConversations, sortConversations } from "../utils/chat";
import useDebounceFn from "../utils/useDebounce";
import { useDebounceValue } from "../utils/useDebounceValue";
import { CustomConversationOperations } from "./CustomConversationOperations";
import { Menu } from "@headlessui/react";
const filters = [{
        id: "all",
        label: "All messages"
    }, {
        id: "unread",
        label: "未読メッセージ"
    }];
const genders = [{
        value: "all",
        label: "All"
    }, {
        value: "male",
        label: "男性"
    }, {
        value: "female",
        label: "女性"
    }];
const LeftSideBar = ({ activeChatId, gender }) => {
    var _a;
    const _useChat = useChat(), conversations = _useChat.conversations, activeConversation = _useChat.activeConversation, users = _useChat.users, setActiveConversation = _useChat.setActiveConversation, getUser = _useChat.getUser, addConversation = _useChat.addConversation, addUser = _useChat.addUser, removeAllConversation = _useChat.removeAllConversation;
    const _useState = useState("all"), _useState2 = _slicedToArray(_useState, 2), filterConversation = _useState2[0], setFilterConversation = _useState2[1];
    const _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), loading = _useState4[0], setLoading = _useState4[1];
    const _useState5 = useState(false), _useState6 = _slicedToArray(_useState5, 2), loadingMore = _useState6[0], setLoadingMore = _useState6[1];
    const _useState7 = useState(1), _useState8 = _slicedToArray(_useState7, 2), page = _useState8[0], setPage = _useState8[1];
    const _useState9 = useState(true), _useState0 = _slicedToArray(_useState9, 2), hasMore = _useState0[0], setHasMore = _useState0[1];
    const _useState1 = useState(gender), _useState10 = _slicedToArray(_useState1, 2), selectedGender = _useState10[0], setSelectedGender = _useState10[1];
    const _useState11 = useState({
        data: [],
        last_page: 0,
        page: 1,
        per_page: 50,
        total: 0
    }), _useState12 = _slicedToArray(_useState11, 2), railsConversations = _useState12[0], setRailsConversations = _useState12[1];
    const _useState13 = useState(""), _useState14 = _slicedToArray(_useState13, 2), searchConversation = _useState14[0], setSearchConversation = _useState14[1];
    const debouncedHandleSearch = useDebounceValue(searchConversation, 300);
    const _useDebounceFn = useDebounceFn(), debounce = _useDebounceFn.debounce;
    const currentPageRef = useRef(1);
    useEffect(() => {
        removeAllConversation();
        loadConversations(1, debouncedHandleSearch, filterConversation, selectedGender, value => setLoading(value));
    }, [debouncedHandleSearch, filterConversation, selectedGender]);
    const loadConversations = (pageToLoad_1, filter_tab_1, ...args_1) => __awaiter(void 0, [pageToLoad_1, filter_tab_1, ...args_1], void 0, function* (pageToLoad, filter_tab, search = "", gender = "all", loadingCallback = value => { }) {
        loadingCallback(true);
        try {
            const response = yield getConversations(pageToLoad, search, filter_tab, gender);
            if (response) {
                setRailsConversations(prev => ({
                    data: pageToLoad === 1 ? response.data : [...prev.data, ...response.data],
                    last_page: response.last_page,
                    page: response.page || 1,
                    per_page: response.per_page || 50,
                    total: response.total
                }));
                setHasMore(pageToLoad < response.last_page);
                setPage(pageToLoad);
                currentPageRef.current = pageToLoad;
            }
        }
        catch (error) {
            console.error("Error loading conversations:", error);
        }
        finally {
            loadingCallback(false);
        }
    });
    const convertConversations = railsConversations => {
        const _railsConversations$d = railsConversations.data, data = _railsConversations$d === void 0 ? [] : _railsConversations$d;
        data.forEach(user => {
            var _a, _b;
            const conversationId = (user.id || nanoid()).toString();
            const userId = user.id.toString() || nanoid();
            const avatarUrl = user.profile.url_1 || user.profile.url_2 || user.profile.url_3;
            addUser(new User({
                id: user.id.toString(),
                presence: new Presence({
                    status: UserStatus.Away,
                    description: (_b = (_a = user === null || user === void 0 ? void 0 : user.last_message) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : "toan"
                }),
                firstName: user === null || user === void 0 ? void 0 : user.twitter_name,
                lastName: user === null || user === void 0 ? void 0 : user.twitter_name,
                username: user === null || user === void 0 ? void 0 : user.twitter_name,
                nickname: user === null || user === void 0 ? void 0 : user.twitter_name,
                email: user === null || user === void 0 ? void 0 : user.email,
                avatar: avatarUrl || "/images/fallback/default.png",
                bio: ""
            }));
            addConversation(createConversation(conversationId, userId, user));
        });
    };
    useEffect(() => {
        convertConversations(railsConversations);
    }, [railsConversations]);
    useEffect(() => {
        if (activeChatId) {
            setActiveConversation(activeChatId);
        }
    }, [activeChatId]);
    useEffect(() => {
        if (gender) {
            setSelectedGender(gender);
        }
    }, [gender]);
    const changeActiveChatId = newChatId => {
        setActiveConversation(newChatId);
        window.history.pushState({}, "", `/chats?chatId=${newChatId}`);
        window.dispatchEvent(new Event("pushstate"));
    };
    const handlePinConversation = userId => {
        chatChannel.perform("pin_conversation", {
            user_id: userId
        });
    };
    const handleUnpinConversation = userId => {
        chatChannel.perform("unpin_conversation", {
            user_id: userId
        });
    };
    const handleChangeSearchConversation = e => {
        setSearchConversation(e.target.value);
    };
    const handleScroll = useCallback(container => {
        const nextPage = currentPageRef.current + 1;
        if (!container || loadingMore || !hasMore)
            return;
        if (currentPageRef.current >= railsConversations.last_page)
            return;
        const scrollTop = container.scrollTop, scrollHeight = container.scrollHeight, clientHeight = container.clientHeight;
        if (scrollHeight - scrollTop <= clientHeight * 1.5) {
            setLoadingMore(true);
            debounce(() => {
                loadConversations(nextPage, debouncedHandleSearch, filterConversation, selectedGender, () => {
                    setLoadingMore(false);
                    const newScrollHeight = container.scrollHeight; // Get updated scrollHeight
                    container.scroll({
                        top: newScrollHeight - clientHeight - 500
                    });
                    currentPageRef.current = nextPage;
                });
            }, 700);
        }
    }, [loadingMore, hasMore, filterConversation, page, railsConversations, debouncedHandleSearch, selectedGender]);
    const handleSelectedGender = value => {
        setSelectedGender(value);
        window.history.pushState({}, "", `/chats?chatId=${activeChatId}&gender=${value}`);
        window.dispatchEvent(new Event("pushstate"));
    };
    return /*#__PURE__*/ React.createElement(Sidebar, {
        position: "left",
        scrollable: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex border-b"
    }, genders.map(gender => /*#__PURE__*/ React.createElement("button", {
        key: gender.value,
        onClick: () => handleSelectedGender(gender.value),
        className: `flex-1 py-2 text-center font-semibold border-b-2 transition-all ${selectedGender === gender.value ? "border-blue-500 text-blue-500" : "border-transparent text-gray-500 hover:text-gray-700"}`
    }, gender.label))), /*#__PURE__*/ React.createElement(ConversationHeader, {
        style: {
            backgroundColor: "#fff"
        }
    }, /*#__PURE__*/ React.createElement(ConversationHeader.Content, {
        className: "py-2"
    }, /*#__PURE__*/ React.createElement("input", {
        type: "text",
        value: searchConversation,
        onChange: handleChangeSearchConversation,
        placeholder: "\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u691C\u7D22...",
        className: "w-full text-lg p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    }))), /*#__PURE__*/ React.createElement(Menu, {
        as: "div",
        className: "relative inline-block w-full"
    }, /*#__PURE__*/ React.createElement(Menu.Button, {
        className: "inline-flex w-full justify-between border-b items-center gap-2 px-4 py-2 rounded-md bg-white"
    }, (_a = filters.find(f => f.id === filterConversation)) === null || _a === void 0 ? void 0 : _a.label, /*#__PURE__*/ React.createElement(ChevronDownIcon, {
        className: "size-4 fill-white/60"
    })), /*#__PURE__*/ React.createElement(Menu.Items, {
        className: "c-filter-dropdown-menu absolute left-0 mt-2 w-full bg-white border rounded-md shadow-lg"
    }, filters.map(g => /*#__PURE__*/ React.createElement(Menu.Item, {
        key: g.id
    }, ({ active }) => /*#__PURE__*/ React.createElement("button", {
        onClick: () => setFilterConversation(g.id),
        className: `block w-full text-left px-4 py-2 ${active ? "bg-blue-500 text-white" : "text-gray-700"}`
    }, g.label))))), /*#__PURE__*/ React.createElement(ConversationList, {
        loading: loading,
        loadingMore: loadingMore,
        onYReachEnd: handleScroll
    }, sortConversations(conversations).map(c => {
        const _ref = (() => {
            var _a;
            const participant = c.participants.length > 0 ? c.participants[0] : undefined;
            if (participant) {
                const user = getUser(participant.id);
                if (user) {
                    return [/*#__PURE__*/ React.createElement(Avatar, null, /*#__PURE__*/ React.createElement("img", {
                            src: user.avatar ? user.avatar : "/images/fallback/default.png",
                            alt: `user_img_${user.id}`,
                            onError: e => {
                                e.target.src = "/images/fallback/default.png";
                            }
                        }), ((_a = c.data) === null || _a === void 0 ? void 0 : _a.pinned_conversation_at) && /*#__PURE__*/ React.createElement("div", {
                            className: "c-pin-avatar-icon bg-blue-700"
                        }, /*#__PURE__*/ React.createElement(Pin, {
                            size: "12px",
                            fill: "white"
                        }))), user.username];
                }
            }
            return [undefined, undefined];
        })(), _ref2 = _slicedToArray(_ref, 2), avatar = _ref2[0], name = _ref2[1];
        return /*#__PURE__*/ React.createElement(Conversation, {
            key: `conversation_id_${c.id}`,
            name: /*#__PURE__*/ React.createElement("div", {
                className: "text-lg"
            }, name),
            info: /*#__PURE__*/ React.createElement("div", {
                dangerouslySetInnerHTML: {
                    __html: c.description
                }
            }),
            active: (activeConversation === null || activeConversation === void 0 ? void 0 : activeConversation.id) === c.id,
            unreadCnt: c.unreadCounter,
            onClick: () => changeActiveChatId(c.id)
        }, avatar, /*#__PURE__*/ React.createElement(Conversation.Operations, {
            visible: true
        }, /*#__PURE__*/ React.createElement(CustomConversationOperations, {
            user: c.data,
            onPinned: handlePinConversation,
            onUnPinned: handleUnpinConversation
        })));
    })));
};
export default LeftSideBar;
